<template>
  <div
    class="option-list__container"
    :class="['type--' + type, ( 'column--' + getNumberOfColumns(type).toString() )]"
  >
    <div
      v-if="options.length"
      class="option-list"
      :class="'type--' + type"
    >
      <option-sub-goal v-for="(option, optionIndex) in options"
        :key="option.Id"
        :optionIndex="optionIndex"
        :stepIndex="currentStepIndex"
        :option="option"
      >
      </option-sub-goal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import OptionSubGoal from '@/components/buy-guide/components/option/option-sub-goal.vue';
//
@Component({
    props: {
    },
    computed: {
      ...mapState({
          currentStepIndex: state => state.buyGuide.currentStepIndex,
          steps: state => state.buyGuide.steps,
          status: state => state.buyGuide.status,
          results: state => state.buyGuide.results
      }),
    },
    components: {
      'option-sub-goal': OptionSubGoal
    },
    methods: {
    }
})
export default class SubGoal extends Vue {
  @Prop() type;
  @Prop() options;
  @Prop() getNumberOfColumns;

  created() {
    // console.log('SubGoal created');
  }

  mounted() {
  }

}

</script>

<style>

</style>
